import { Select } from '@cloudscape-design/components';
import React, { useEffect } from 'react';
import { setParameters } from '../../pages/commons/functions';
import { useGlobalState } from '../../pages/context/GlobalStateContext';

interface SelectPagingTypeProps {
  onSelect?: (pageSize: number) => void;
  pageSize?: number;
}
const SelectPaging: React.FC<SelectPagingTypeProps> = ({
  pageSize = 10,
  onSelect
}) => {

  const { parameters } = useGlobalState();



  useEffect(() => {
    if (!parameters.pageSize) {
      setParameters({ ...parameters, pageSize: pageSize });
    }
  }, [parameters.pageSize]);

  useEffect(() => {
  }, [pageSize]);


  return (
    <div style={{ width: 100 }}>

      <Select
        selectedOption={{ value: parameters && parameters.pageSize ? parameters.pageSize.toString() : "10", label: parameters && parameters.pageSize ? parameters.pageSize.toString() : "10" }}
        onChange={({ detail }) => {
          setParameters({ ...parameters, pageSize: Number(detail.selectedOption.value) });
          if (onSelect) {
            onSelect(Number(detail.selectedOption.value));
          }
        }}
        options={[
          { value: "10", label: "10" },
          { value: "20", label: "20" },
          { value: "50", label: "50" },
          { value: "100", label: "100" }
        ]}
      />
    </div>
  );
};

export default SelectPaging;